import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const seoApi = createApi({
  reducerPath: "seoApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + `statics/seo`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.userSlice?.token; // ✅ بدون store
      if (token) headers.set("Authorization", `Bearer ${token}`);
      return headers;
    },
  }),
  // /topup/init
  // fetch(`/api/seo/${encodeURIComponent(path)}`)
  //   .
  endpoints: (builder) => ({
    getSeoByPath: builder.query({
      query: ({ path }) => {
              const encodedPath = encodeURIComponent(path);
        return {
          url: `/${encodedPath}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetSeoByPathQuery } = seoApi;
